import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// @ts-ignore
import traverseISODate from '@segment/isodate-traverse';
import { eventType } from '../index';
import { SegmentEventTypes } from './types';
export const buildContext = context => {
  return _objectSpread(_objectSpread({}, context.context), {}, {
    page: undefined,
    // To stay consistent with SegmentIo
    userAgent: navigator.userAgent
  });
};
export const prepareEventProperties = properties => {
  const propertiesWithoutUndefined = nestedRemoveUndefinedValues(properties);
  return traverseISODate(propertiesWithoutUndefined);
}; // This function will essentially deepClone as well

export const nestedRemoveUndefinedValues = obj => {
  const clone = {};
  Object.keys(obj).forEach(key => {
    const value = getValueOfObject(obj, key);

    if (value !== undefined) {
      if (typeof value === 'object' && value !== null) {
        clone[key] = nestedRemoveUndefinedValues(value);
      } else {
        clone[key] = value;
      }
    }
  });
  return clone;
}; // Using ts-ignore everywhere urked me

const getValueOfObject = (obj, key) => {
  // @ts-ignore This is an object
  return obj[key];
}; // Utils for event comparison


export const getTransformUUIDFromEvent = event => {
  const {
    type
  } = event.msg;

  switch (type) {
    case SegmentEventTypes.IDENTIFY:
      return getTransformUUIDFromIdentifyEvent(event.msg);

    case SegmentEventTypes.PAGE:
      return getTransformUUIDFromPageEvent(event.msg);

    case SegmentEventTypes.TRACK:
      return getTransformUUIDFromTrackEvent(event.msg);
  }
};

const getTransformUUIDFromIdentifyEvent = event => {
  var _event$traits;

  return (_event$traits = event.traits) === null || _event$traits === void 0 ? void 0 : _event$traits.transformUUID;
};

const getTransformUUIDFromPageEvent = event => {
  var _event$properties;

  return (_event$properties = event.properties) === null || _event$properties === void 0 ? void 0 : _event$properties.transformUUID;
};

const getTransformUUIDFromTrackEvent = event => {
  var _event$properties2;

  return (_event$properties2 = event.properties) === null || _event$properties2 === void 0 ? void 0 : _event$properties2.transformUUID;
};

export const getEventType = event => {
  const {
    type
  } = event.msg;

  switch (type) {
    case SegmentEventTypes.IDENTIFY:
      return getEventTypeFromIdentifyEvent(event.msg);

    case SegmentEventTypes.PAGE:
      return getEventTypeFromPageEvent(event.msg);

    case SegmentEventTypes.TRACK:
      return getEventTypeFromTrackEvent(event.msg);
  }
};

const getEventTypeFromIdentifyEvent = event => {
  return eventType.IDENTIFY;
};

const getEventTypeFromPageEvent = event => {
  return eventType.SCREEN;
};

const getEventTypeFromTrackEvent = event => {
  return event.properties.eventType;
};

export const compareEvents = (segmentEvent, ourEvent) => {
  const {
    messageId
  } = segmentEvent.msg;
  const packageMismatches = packageMismatch(segmentEvent, ourEvent);
  const eventMismatches = compareEvent(segmentEvent.msg, ourEvent.msg);
  const mismatches = packageMismatches.concat(eventMismatches);
  const mismatch = {
    eventId: messageId,
    type: getEventType(segmentEvent),
    mismatches
  };
  return mismatch;
};

const compareEvent = (segmentEvent, ourEvent) => {
  if (segmentEvent && ourEvent) {
    return getMismatches('msg', segmentEvent, ourEvent, [// All of these can change safely between the two events
    'msg.messageId', 'msg.sentAt', 'msg.timestamp', // This field can be set to random things depending on query params and is not processed in the backend
    'msg.context.campaign']);
  } else if (segmentEvent) {
    return [{
      path: 'msg',
      type: 'missing'
    }];
  } else {
    return [{
      path: 'msg',
      type: 'added',
      value: ourEvent
    }];
  }
};

const packageMismatch = (segmentEvent, ourEvent) => {
  return getMismatches('', segmentEvent, ourEvent, ['msg']);
};

const getMismatches = (pathToObject, segmentObject, ourObject, ignoredKeys = []) => {
  const segmentKeys = Object.keys(segmentObject).filter(key => !ignoredKeys.includes(createRelativeKey(pathToObject, key)));
  const ourKeys = Object.keys(ourObject).filter(key => !ignoredKeys.includes(createRelativeKey(pathToObject, key)));
  const mismatches = ourKeys.filter(key => !segmentKeys.includes(key)).map(key => ({
    path: createRelativeKey(pathToObject, key),
    type: 'added',
    value: valueOrLiteralUndefined(getValueOfObject(ourObject, key))
  }));
  segmentKeys.forEach(key => {
    const segmentValue = getValueOfObject(segmentObject, key);
    const ourValue = getValueOfObject(ourObject, key);

    if (!(key in ourObject)) {
      mismatches.push({
        path: createRelativeKey(pathToObject, key),
        type: 'missing'
      });
    } else if (typeof segmentValue === 'object' && segmentValue !== null) {
      if (typeof ourValue !== 'object' || ourValue === null) {
        mismatches.push({
          path: createRelativeKey(pathToObject, key),
          type: 'different',
          value: valueOrLiteralUndefined(ourValue)
        });
      } else {
        const nestedMismatches = getMismatches(createRelativeKey(pathToObject, key), segmentValue, ourValue, ignoredKeys);
        nestedMismatches.forEach(mismatch => mismatches.push(mismatch));
      }
    } else {
      if (segmentValue !== ourValue) {
        // NaN !== NaN so we have to do a specific check to see if both values are NaN
        if (!(typeof segmentValue === 'number' && isNaN(segmentValue) && typeof ourValue === 'number' && isNaN(ourValue))) {
          mismatches.push({
            path: createRelativeKey(pathToObject, key),
            type: 'different',
            value: valueOrLiteralUndefined(ourValue)
          });
        }
      }
    }
  });
  return mismatches;
};

const createRelativeKey = (pathToObject, currentKey) => {
  return pathToObject ? `${pathToObject}.${currentKey}` : currentKey;
};

const valueOrLiteralUndefined = item => {
  if (item === undefined) {
    return 'literal `undefined`';
  } else if (item === null) {
    return 'literal `null`';
  } else if (typeof item === 'number' && isNaN(item)) {
    return 'literal `NaN`';
  }

  return item;
};